<template>
  <div class="row q-ma-xl">
    <div class="col">
      <div class="text-h4 q-mb-xl">Terms of Use</div>
      <TermsOfUse></TermsOfUse>
      <div class="q-mt-xl q-mb-xl q-gutter-sm">
        <q-btn
          :ripple="false"
          color="primary"
          @click="() => $router.push('login')"
          label="Return to Login"
        ></q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import TermsOfUse from "@/components/TermsOfUse";

export default {
  name: "TermsOfUseView",
  components: {
    TermsOfUse,
  },
};
</script>
<style lang="scss" scoped></style>
